import React from "react";

import { Box, Typography, IconButton, Link } from "@mui/material";

import ModalContainer from "components/ModalContainer";
import { ReactComponent as CloseIcon } from "assets/images/icons/icn_close.svg";
import { useBreadStorageContext } from "contexts/BreadStorageContext";

const LinkModal = ({
  open,
  onClose,
  title = "Upgrade to Nuclias Unity Pro",
  content = "Your configuration contains Nuclias Unity Pro features. Please subscribe to Nuclias Unity Pro to save these changes.",
  linkText = "Go to License Management",
  onLinkClick,
}) => {
  const { setBread } = useBreadStorageContext();

  if (!open) return null;

  const handleLinkClick = () => {
    let selectedBreadcrumbs;

    try {
      selectedBreadcrumbs = JSON.parse(
        localStorage.getItem("selectBreadcrumbs") || "{}",
      );
    } catch {
      selectedBreadcrumbs = {};
    }

    const isMspScope =
      selectedBreadcrumbs?.realm?.hasManageOrg === true &&
      !selectedBreadcrumbs?.orgs?.id;
    const licenseScopeBreadcrumbs = {
      ...selectedBreadcrumbs,
      // License Management is organization-level. Do not retain a selected
      // site, otherwise the layout continues to render the site-level menu.
      site: {},
      // MSP License Management is realm-level, so an organization selection
      // must be cleared as well.
      ...(isMspScope && { orgs: {} }),
    };

    localStorage.setItem(
      "selectBreadcrumbs",
      JSON.stringify(licenseScopeBreadcrumbs),
    );
    setBread(licenseScopeBreadcrumbs);
    onLinkClick?.();
  };

  return (
    <ModalContainer
      display={open}
      modalWidth="500px"
      transparentBackdrop
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Typography
          id="link-modal-title"
          sx={{
            fontSize: "18px",
            fontWeight: 600,
          }}
        >
          {title}
        </Typography>

        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Content */}
      {content && (
        <Typography
          sx={{
            fontSize: "14px",
            lineHeight: 1.6,
            mb: 2,
            whiteSpace: "pre-line",
          }}
        >
          {content}
        </Typography>
      )}

      {/* Link */}
      {linkText && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            py: 2,
          }}
        >
          <Link
            component="button"
            type="button"
            underline="hover"
            onClick={handleLinkClick}
            sx={{
              fontSize: "14px",
              cursor: "pointer",
              fontFamily: "inherit",
              border: "none",
              backgroundColor: "transparent",
            }}
          >
            {linkText}
          </Link>
        </Box>
      )}
    </ModalContainer>
  );
};

export default LinkModal;
